import { Box, Typography } from "@mui/material"

export const getBulletPointLine = (text: string, showBullet: boolean = true) => (
  <Box sx={theme => ({ display: 'flex', flexDirection: 'row', color: theme.palette.text.secondary })}>
    <Typography sx={{ width: '15px' }}>{showBullet ? '•' : ''}</Typography>
    <Typography>{text}</Typography>
  </Box>
)